import { Wallet } from "lucide-react";

/**
 * Digital wallet-style loyalty card, styled after Apple Wallet passes.
 */
export default function WalletCard({
  title = "STREET EATS",
  subtitle = "LOYALTY MEMBER",
  bg = "linear-gradient(135deg,#0B1F3A 0%,#07182D 100%)",
  accent = "#D4A017",
  stamps = 7,
  total = 10,
  balance,
  points,
  variant = "stamps",
  logoLabel = "SE",
  textOnLight = false,
}) {
  const textColor = textOnLight ? "#0B1F3A" : "#FFFFFF";
  const mutedTextColor = textOnLight ? "rgba(11,31,58,0.65)" : "rgba(255,255,255,0.7)";
  const softTextColor = textOnLight ? "rgba(11,31,58,0.55)" : "rgba(255,255,255,0.6)";
  const borderColor = textOnLight ? "rgba(11,31,58,0.2)" : "rgba(255,255,255,0.2)";
  const emptyColor = textOnLight ? "rgba(11,31,58,0.35)" : "rgba(255,255,255,0.4)";

  return (
    <div
      className="wallet-card"
      style={{ background: bg, color: textColor }}
      data-testid={`wallet-card-${variant}`}
    >
      <div className="relative z-10 flex items-start justify-between">
        <div className="flex items-center gap-2">
          <div
            className="w-8 h-8 grid place-items-center font-display text-sm rounded-sm"
            style={{ background: accent, color: textOnLight ? "#FFFFFF" : "#07182D" }}
          >
            {logoLabel}
          </div>
          <div>
            <div
              className="font-mono text-[10px] uppercase tracking-widest"
              style={{ color: mutedTextColor }}
            >
              {subtitle}
            </div>
            <div className="font-display text-base uppercase leading-none">
              {title}
            </div>
          </div>
        </div>
        <Wallet size={16} style={{ color: softTextColor }} />
      </div>

      <div className="relative z-10 mt-6">
        {variant === "stamps" && (
          <>
            <div
              className="font-mono text-[10px] uppercase tracking-widest mb-2"
              style={{ color: mutedTextColor }}
            >
              Progress · {stamps}/{total}
            </div>
            <div className="grid grid-cols-5 gap-1.5">
              {Array.from({ length: total }).map((_, i) => (
                <div
                  key={i}
                  className="aspect-square rounded-full border grid place-items-center text-[10px]"
                  style={{
                    background: i < stamps ? accent : "transparent",
                    color: i < stamps ? (textOnLight ? "#FFFFFF" : "#07182D") : emptyColor,
                    borderColor: i < stamps ? accent : borderColor,
                  }}
                >
                  ★
                </div>
              ))}
            </div>
          </>
        )}

        {variant === "cashback" && (
          <div>
            <div
              className="font-mono text-[10px] uppercase tracking-widest"
              style={{ color: mutedTextColor }}
            >
              Points balance
            </div>
            <div
              className="font-display text-3xl leading-none mt-1"
              style={{ color: accent }}
            >
              {points ?? "1,240"}
            </div>
            <div
              className="font-mono text-[10px] mt-1"
              style={{ color: softTextColor }}
            >
              = ${((points ?? 1240) / 100).toFixed(2)} cashback
            </div>
          </div>
        )}

        {variant === "gift" && (
          <div>
            <div
              className="font-mono text-[10px] uppercase tracking-widest"
              style={{ color: mutedTextColor }}
            >
              Gift balance
            </div>
            <div
              className="font-display text-3xl leading-none mt-1"
              style={{ color: accent }}
            >
              ${balance ?? "50"}.00
            </div>
            <div
              className="font-mono text-[10px] mt-1"
              style={{ color: softTextColor }}
            >
              Redeem in-store or online
            </div>
          </div>
        )}

        {variant === "discount" && (
          <div>
            <div
              className="font-mono text-[10px] uppercase tracking-widest"
              style={{ color: mutedTextColor }}
            >
              Tier · Gold
            </div>
            <div
              className="font-display text-3xl leading-none mt-1"
              style={{ color: accent }}
            >
              15% OFF
            </div>
            <div
              className="font-mono text-[10px] mt-1"
              style={{ color: softTextColor }}
            >
              Every visit, forever
            </div>
          </div>
        )}
      </div>

      <div
        className="relative z-10 mt-4 flex items-center justify-between font-mono text-[10px] uppercase tracking-widest"
        style={{ color: softTextColor }}
      >
        <span>·····  6421</span>
        <span>{variant.toUpperCase()}</span>
      </div>
    </div>
  );
}
